import { Outlet } from 'react-router-dom';

import ScrollToTop from 'navigation/extensions/ScrollToTop';
import TrackLastPublicRoute from 'navigation/extensions/TrackLastPublicRoute';
import { TechnicalUserGuard } from 'navigation/wrapper/security/TechnicalUserGuard';
import AppProviders from 'providers/AppProviders';

export const RootWrapper = () => {
  return (
    <AppProviders>
      <ScrollToTop />
      <TrackLastPublicRoute />
      <TechnicalUserGuard />
      <Outlet />
    </AppProviders>
  );
};
